import React from 'react';
import { Button } from '../button';
import LinkGroup from './LinkGroup';
import classNames from 'classnames';
const InternalLink = (props, ref) => {
    return (React.createElement(Button, { ref: ref, ...props, className: classNames({
            [`link-secondary`]: props.type === 'secondary',
            [props.status]: props.status
        }, props.className), type: 'link' }));
};
const Link = React.forwardRef(InternalLink);
Link.Group = LinkGroup;
// export default withConfigProvider(Link);
export default Link;
